
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M0 15.272a.727.727 0 00.727.727h1.226a6.5 6.5 0 004.629-1.916l8.451-8.451A3.3 3.3 0 1010.367.966L1.916 9.417A6.5 6.5 0 000 14.047zM14 1.997a1.84 1.84 0 010 2.607l-.913.913L10.48 2.91l.92-.913a1.884 1.884 0 012.6 0zM1.455 14.047a5.062 5.062 0 011.491-3.6l6.509-6.509 2.607 2.607-6.509 6.509a5.062 5.062 0 01-3.6 1.491h-.5zM1.887 5.661V3.774a1.888 1.888 0 011.888-1.888h1.888a.629.629 0 000-1.258H3.775A3.146 3.146 0 00.629 3.774v1.888a.629.629 0 001.258 0zM12.226 15.371a3.146 3.146 0 003.146-3.146v-1.888a.629.629 0 00-1.258 0v1.888a1.888 1.888 0 01-1.888 1.883h-1.888a.629.629 0 000 1.258z"}})])
          )
        }
      }
    